
    import "src/shared/components/Preferences/index.module.scss?farm_css_modules";
    
    export default {"button": `button-ea3c36e2`,"col": `col-ea3c36e2`,"preferenceRow": `preferenceRow-ea3c36e2`,"profilePage": `profilePage-ea3c36e2`,"row1": `row1-ea3c36e2`,"row2": `row2-ea3c36e2`,"rowData": `rowData-ea3c36e2`,"secondaryText": `secondaryText-ea3c36e2`,"title": `title-ea3c36e2`}
    